<template>
  <el-dialog v-el-drag-dialog custom-class="" :close-on-click-modal="false" :visible.sync="innerVisible" :title="$t('CargoMsg.Cargo_FinancialAudit')" width="500px" @close="cancel">
    <div class="app-main-inner-row" style="padding-bottom: 10px;">
      <el-form :label-width="isZh ? '110px' : '160px'" label-position="left" @submit.native.prevent>
        <div class="el-form-item-wrapper">
          <el-form-item :label="$t('CargoMsg.Cargo_PleaseConfirmFinancialDate')">
            <el-date-picker
              v-model="accountDate"
              no="accountDate"
              type="date"
              style="width:251px;"
              clearable
              :disabled="!editApprovalDate"
              :picker-options="pickerOptions"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ItemNo')">
            <el-input v-model="poNo" no="poNo" :disabled="!isEditable" style="width:251px;" />
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div slot="footer">
      <el-button no="Confirm" type="primary" size="mini" @click="confirm">{{ $t('Clearing.Confirm') }}</el-button>
      <el-button no="Cancel" size="mini" @click="cancel">{{ $t('Clearing.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>

import { Assert } from '@/utils/validate'
import moment from 'moment'

export default {
  name: 'CheckDialog',
  components: { },
  props: {
    showPageDate: { type: Boolean, required: false }, // 是否使用上次选中时间
    pageDate: { type: Date, required: false },
    visible: { type: Boolean, required: true },
    isEditable: { type: Boolean, required: true },
    editApprovalDate: { type: Boolean, required: false },
    poNo: { type: String, required: false }
  },
  data() {
    return {
      innerVisible: this.visible,
      accountDate: new Date(),
      pickerOptions: {
        disabledDate: this.disabledDate
      }
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  watch: {
    accountDate() {

    }
  },
  created() {
    if (this.showPageDate) {
      this.accountDate = moment(new Date(this.pageDate)).format('YYYY-MM-DD')
    }
  },
  methods: {
    disabledDate(currDate) {
      return currDate > new Date()
    },
    cancel() {
      this.$emit('update:visible', false)
      this.$emit('returnDatePage', this.accountDate)
    },
    close() {
      this.$emit('returnDatePage', this.accountDate)
    },
    async confirm() {
      await Assert.isNotBlank(this.accountDate, this.$t('CargoMsg.Cargo_PleaseSelectReviewDate'), 'warning')
      this.$emit('confirm', { accountDate: this.accountDate, poNo: this.poNo })
    }
  }
}
</script>

<style lang="scss">
</style>
